import styled from "styled-components";

import { LARGE_SCREEN } from "../../constants/screenSizes";
import { typographyWeights } from "../constants/fontWeightOptions";
import { baseTextStyles } from "../shared/styled";

export const PrimaryLargeBase = styled.h1`
  ${baseTextStyles}
  font-size: 40px;
  font-weight: ${props => typographyWeights[props.weight]};
  line-height: 50px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 32px;
    line-height: 40px;
  }
`;
